// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1rQ48","inner":"Footer_inner__2aM01","nextIcon":"Footer_nextIcon__O7oRh","innerLeft":"Footer_innerLeft__2Noda"};